var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a71f0d4e3167fe10c018afd7485e5a601db14b60"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["broker-app@onpreo"]={id:"a71f0d4e3167fe10c018afd7485e5a601db14b60"};
      